import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ButtonBase from "@mui/material/ButtonBase";
import Tooltip from "@mui/material/Tooltip";
import React from "react";

import { TestIds } from "@storyboard/web-test-ids/testIds";
import { zinc } from "@/ui/tokens";
import { headerButtonSx } from "./DispatchFilterMenu";

/**
 * The header's two actions over many rows, always present so a dispatcher learns where they live: "Acknowledge" works
 * the ticked rows and sits disabled until there are some; "Fleet message" goes to the ticked drivers, else to every
 * driver the page shows, and is disabled only when the page shows no one.
 */
export default React.memo(function DispatchBulkActions({
  tickedCount,
  recipientCount,
  onAcknowledge,
  onFleetMessage,
}: {
  tickedCount: number;
  recipientCount: number;
  onAcknowledge: () => void;
  onFleetMessage: () => void;
}) {
  const disabledSx = { "&:disabled": { color: zinc[500], bgcolor: zinc[800] } } as const;
  const fleetTitle =
    recipientCount === 0
      ? "No drivers to message"
      : tickedCount > 0
        ? `Message the ${recipientCount} ticked driver${recipientCount === 1 ? "" : "s"}`
        : `Message every driver shown (${recipientCount})`;
  return (
    <>
      <Tooltip
        title={
          tickedCount > 0
            ? `Acknowledge the ${tickedCount} ticked row${tickedCount === 1 ? "" : "s"}`
            : "Tick rows to acknowledge them"
        }
      >
        <span>
          <ButtonBase
            data-sb={TestIds.dispatch.acknowledgeSelected}
            disabled={tickedCount === 0}
            onClick={onAcknowledge}
            sx={{ ...headerButtonSx(false), ...disabledSx }}
          >
            <DoneAllIcon sx={{ fontSize: 18 }} />
            Acknowledge
          </ButtonBase>
        </span>
      </Tooltip>
      <Tooltip title={fleetTitle}>
        <span>
          <ButtonBase
            data-sb={TestIds.dispatch.fleetMessage}
            disabled={recipientCount === 0}
            onClick={onFleetMessage}
            sx={{ ...headerButtonSx(false), ...disabledSx }}
          >
            <CampaignOutlinedIcon sx={{ fontSize: 18 }} />
            Fleet message
          </ButtonBase>
        </span>
      </Tooltip>
    </>
  );
});
